<!-- <div [class.hidden]="show === false"> -->
<div [hidden]="show === false">
  <div class="loader-overlay">
    <div class="loader-ogo"></div>
  </div>
</div>
